module.exports = __webpack_public_path__ + "static/media/379.319335d9.png";